// extracted by mini-css-extract-plugin
module.exports = {"deskMode":"Dashboard_deskMode__Sh8p_","datePicker":"Dashboard_datePicker__3Yevr","dashboardloader":"Dashboard_dashboardloader__68Nd_","mobileMode":"Dashboard_mobileMode__a_7dN"};